module.exports = __webpack_public_path__ + "img/Frame 1102hrp2.f05f4ba9.png";